<div class="main">
  <nav class="breadcrumb-nav border-0 mb-0">
    <div class="container">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
        <li class="breadcrumb-item active">Disiscrizione</li>
      </ol>
    </div>
  </nav>

  <div class="page-content pt-8 pb-8">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">

          <!-- Stato iniziale: form -->
          <ng-container *ngIf="stato === 'form'">
            <h2 class="title text-center mb-2">Vuoi disiscriverti?</h2>
            <p class="text-center text-muted mb-4">
              L'indirizzo <strong>{{ email }}</strong> non riceverà più comunicazioni da MyLiteLED.
            </p>

            <div class="form-group mb-3">
                <label for="motivo" class="font-weight-bold">Motivo (opzionale)</label>
                <select id="motivo" class="form-control" [(ngModel)]="motivoSelezionato" name="motivo">
                    <option value="">— Seleziona —</option>
                    <option value="Troppe email">Ricevo troppe email</option>
                    <option value="Non pertinente">Il contenuto non mi interessa</option>
                    <option value="Non mi sono iscritto">Non mi sono mai iscritto</option>
                    <option value="Altro">Altro</option>
                </select>
            </div>

            <button class="btn btn-primary btn-block" (click)="conferma()" [disabled]="loading">
              <span *ngIf="loading">Elaborazione...</span>
              <span *ngIf="!loading">Confermo la disiscrizione</span>
            </button>
          </ng-container>

          <!-- Stato: conferma avvenuta -->
          <ng-container *ngIf="stato === 'ok'">
            <div class="text-center">
              <i class="icon-check-circle" style="font-size: 3rem; color: #28a745;"></i>
              <h2 class="title mt-3">Disiscrizione confermata</h2>
              <p class="text-muted">
                L'indirizzo <strong>{{ email }}</strong> è stato rimosso dalla nostra lista.<br>
                Non riceverai più comunicazioni commerciali da MyLiteLED.
              </p>
              <a routerLink="/" class="btn btn-outline-primary mt-3">Torna alla home</a>
            </div>
          </ng-container>

          <!-- Stato: errore -->
          <ng-container *ngIf="stato === 'errore'">
            <div class="text-center">
              <h2 class="title mt-3">Qualcosa non ha funzionato</h2>
              <p class="text-muted">
                Non è stato possibile completare la disiscrizione.<br>
                Scrivi a <a href="mailto:info@myliteled.com">info@myliteled.com</a> per assistenza.
              </p>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>